import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import IncomingCallNotification from '../components/IncomingCallNotification';
import Sidebar from '../components/Sidebar';
import TaroBot from '../components/TaroBot';
import { NotificationProvider } from '../contexts/NotificationContext';
import { auth } from '../firebase';
import { clientApi } from '../services/clientApi';

const ClientLayout: React.FC = () => {
  const location = useLocation();
  const [currentUser, setCurrentUser] = useState(auth.currentUser);
  const [clientId, setClientId] = useState<string | undefined>(undefined);
  const [sidebarWidth, setSidebarWidth] = useState(280);

  // Route'dan activeTab'i belirle
  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('/nutrition')) return 'nutrition';
    if (path.includes('/weight')) return 'weight';
    if (path.includes('/messages')) return 'messages';
    if (path.includes('/my-dietitian-settings')) return 'my-dietitian-settings';
    if (path.includes('/my-dietitian')) return 'my-dietitian';
    if (path.includes('/select-dietitian')) return 'select-dietitian';
    if (path.includes('/settings')) return 'settings';
    return 'dashboard';
  };

  // Auth state değişikliğini dinle
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
    });
    return () => unsubscribe();
  }, []);

  // Client ID'yi yükle
  useEffect(() => {
    const loadClientId = async () => {
      if (currentUser?.email) {
        try {
          const client = await clientApi.getClientByEmail(currentUser.email);
          setClientId(client.id);
        } catch (error) {
          console.error('Client ID yüklenemedi:', error);
        }
      }
    };

    loadClientId();
  }, [currentUser]);

  return (
    <NotificationProvider currentUserId={clientId} userRole="client">
      <Box
        sx={{
          display: 'flex',
          minHeight: '100vh',
          bgcolor: '#f5f7fa',
          width: '100%',
          maxWidth: '100vw',
          overflowX: 'hidden',
        }}
      >
        <Sidebar
          userRole="client"
          activeTab={getActiveTab()}
          onTabChange={() => {}} // Artık navigation Sidebar içinde navigate ile yapılacak
          onWidthChange={setSidebarWidth}
        />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            px: 1.5,
            pt: 1,
            ml: { xs: 0, md: `${sidebarWidth}px` },
            mt: { xs: 0, md: 0 },
            mb: 2,
            transition: 'margin-left 0.3s ease',
            width: '100%',
            maxWidth: '100vw',
            overflowX: 'auto',
            overflowY: 'hidden',
          }}
        >
          <Outlet />
        </Box>

        {/* Global Gelen Arama Bildirimi */}
        {clientId && (
          <IncomingCallNotification
            currentUserId={clientId}
            isDietitian={false}
          />
        )}

        {/* Taro Bot - Mesajlaşma sayfasında gizle */}
        {clientId && !location.pathname.includes('/messages') && (
          <TaroBot clientId={clientId} />
        )}
      </Box>
    </NotificationProvider>
  );
};

export default ClientLayout;
